import { AUTH_DEVICE_COOKIE_NAME } from '@/auth/auth-policy';

export function ensureAuthDeviceCookie() {
  if (typeof document === 'undefined') {
    return;
  }

  if (getCookieValue(AUTH_DEVICE_COOKIE_NAME)) {
    return;
  }

  const deviceId =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  // biome-ignore lint/suspicious/noDocumentCookie: the auth hook reads this cookie after Google auth
  document.cookie = `${AUTH_DEVICE_COOKIE_NAME}=${encodeURIComponent(
    deviceId
  )}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
}

function getCookieValue(name: string) {
  return document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(`${name}=`))
    ?.split('=')
    .slice(1)
    .join('=');
}
